var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseMonoColor(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.47517 12.5254C5.97451 15.0248 10.0267 15.0248 12.5261 12.5254C15.0254 10.0261 15.0254 5.97384 12.5261 3.4745C10.0267 0.975155 5.97451 0.975155 3.47517 3.4745C0.975827 5.97384 0.975827 10.0261 3.47517 12.5254ZM2.3438 13.6568C5.46798 16.781 10.5333 16.781 13.6574 13.6568C16.7816 10.5326 16.7816 5.46731 13.6574 2.34313C10.5333 -0.781044 5.46798 -0.781044 2.3438 2.34313C-0.780373 5.46731 -0.780373 10.5326 2.3438 13.6568Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4519 5.54871C10.7643 5.86113 10.7643 6.36766 10.4519 6.68008L6.6807 10.4513C6.36828 10.7637 5.86175 10.7637 5.54933 10.4513C5.23692 10.1389 5.23691 9.63235 5.54933 9.31993L9.32055 5.54871C9.63297 5.2363 10.1395 5.2363 10.4519 5.54871Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4518 10.4512C10.1394 10.7636 9.63289 10.7636 9.32047 10.4512L5.54926 6.67996C5.23684 6.36755 5.23684 5.86102 5.54926 5.5486C5.86167 5.23618 6.3682 5.23618 6.68062 5.5486L10.4518 9.31982C10.7643 9.63223 10.7643 10.1388 10.4518 10.4512Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseMonoColor);
export default __webpack_public_path__ + "static/media/close-mono-color.bed11551725719849251a5247bc87e24.svg";
export { ForwardRef as ReactComponent };